import { DashboardLayoutConfig } from '../../infrastructure/contracts/layout.contract';

/**
 * SuperAdmin Dashboard Layout
 *
 * Inherits the Admin layout but prepends the God Mode Panel at the very top.
 */
export const superAdminLayout: DashboardLayoutConfig = {
  id: 'superadmin-dashboard-layout',
  name: 'SuperAdmin Layout',
  description: 'Layout for Owners (SuperAdmins)',
  role: 'superadmin',
  widgets: [
    // ── Row 0: God Mode Panel ─────────────────────────────────────
    { id: 'superadmin-god-mode',    w: 12, h: 2, x: 0, y: 0 },

    // ── Row 0.5: Company Health (CEO) ─────────────────────────────
    { id: 'dash-company-health',    w: 12, h: 3, x: 0, y: 2 },

    // ── Row 1: KPI Cards ──────────────────────────────────────────
    { id: 'admin-total-leads',      w: 4, h: 1, x: 0,  y: 2 },
    { id: 'admin-leads-today',      w: 4, h: 1, x: 4,  y: 2 },
    { id: 'admin-leads-week',       w: 4, h: 1, x: 8,  y: 2 },
    { id: 'admin-active-employees', w: 4, h: 1, x: 0,  y: 3 },
    { id: 'admin-scans-today',      w: 4, h: 1, x: 4,  y: 3 },
    { id: 'admin-converted-leads',  w: 4, h: 1, x: 8,  y: 3 },

    // ── Row 1.5: Intelligence & Actions ───────────────────────────
    { id: 'dash-ai-briefing',        w: 6, h: 3, x: 0,  y: 4 },
    { id: 'dash-pending-approvals',  w: 6, h: 3, x: 6,  y: 4 },

    // ── Row 2: Live Operations & Charts ───────────────────────────
    { id: 'dash-running-jobs',      w: 12, h: 3, x: 0,  y: 4 },
    { id: 'admin-lead-velocity',    w: 8, h: 4, x: 0,  y: 7 },
    { id: 'admin-pipeline-health',  w: 4, h: 4, x: 8,  y: 7 },

    // ── Row 3: Team Leaderboard (full width) ──────────────────────
    { id: 'admin-team-leaderboard', w: 12, h: 4, x: 0, y: 11 },

    // ── Row 4: Operational Lists ──────────────────────────────────
    { id: 'dash-pending-tasks',     w: 4, h: 4, x: 0,  y: 15 },
    { id: 'dash-active-projects',   w: 4, h: 4, x: 4,  y: 15 },
    { id: 'dash-announcements',     w: 4, h: 4, x: 8,  y: 15 },

    // ── Row 5: Upcoming Meetings + Notifications ──────────────────
    { id: 'dash-upcoming-meetings', w: 6, h: 4, x: 0,  y: 19 },
    { id: 'dash-notifications',     w: 6, h: 4, x: 6,  y: 19 },
    { id: 'dash-recent-activities', w: 12, h: 4, x: 0, y: 23 },
  ],
};
